<template>
  <div class="t-marker">
    <v-toolbar color="primary" dense flat dark>
      <v-toolbar-title class="body-2">{{ label }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="fnClose" icon small>
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-sheet id="navigate" color="grey">
      <div id="mapArea"></div>
      <v-speed-dial
        v-model="fab"
        class="mb-8"
        direction="left"
        transition="slide-x-reverse-transition"
        bottom
        right
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="white" fab>
            <v-icon v-if="fab"> mdi-close </v-icon>
            <v-icon v-else> mdi-map-marker </v-icon>
          </v-btn>
        </template>
        <v-btn @click="fnNavigate(coords, 'baidu')" small>百度</v-btn>
        <v-btn @click="fnNavigate(coords, 'gaode')" small>高德</v-btn>
        <v-btn @click="fnNavigate(coords)" small>腾讯</v-btn>
      </v-speed-dial>
    </v-sheet>
  </div>
</template>

<script>
import config from "@/utils/config";
import { TXMap } from "@/utils/mapt";
import altCoords from "./alt_coords";
export default {
  name: "TMarker",
  props: {
    label: { type: String, required: false, default: "地理位置" },
    marker: {
      type: String,
      required: false,
      default: null,
    },
    coords: { type: Array, required: false, default: () => [] },
    center: {
      type: Array,
      required: false,
      default: () => [25.066495, 102.719493],
    },
    zoom: { type: Number, required: false, default: 15 },
  },
  data: () => ({
    mapKey: config.txMapKey,
    markerIcon: null,
    fab: false,
  }),
  watch: {
    coords(val) {
      if (val) {
        this.$nextTick(() => {
          document.getElementById("mapArea").innerHTML = "";
          this.fnDrawMap(val, this.zoom);
        });
      }
    },
    zoom(val) {},
  },
  computed: {},
  mounted() {
    if (!this.coords) {
      this.coords = this.center;
    }
    if (!this.marker) {
      this.markerIcon = require("@/assets/images/markerDefault.png");
    } else {
      this.markerIcon = this.marker;
    }
    this.fnDrawMap(this.coords, this.zoom);
    // this.fnDrawMap(this.spoint, this.epoint, this.zoom);
  },
  methods: {
    async fnDrawMap(point, zoom) {
      point = altCoords.BDtoGD(point[0], point[1]);
      await TXMap(this.mapKey).then((qq) => {
        var center = new TMap.LatLng(Number(point[0]), Number(point[1]));
        var map = new TMap.Map(document.getElementById("mapArea"), {
          // 地图的中心地理坐标。
          center: center,
          zoom: zoom,
        });
        //创建并初始化MultiMarker
        var markerLayer = new TMap.MultiMarker({
          map: map, //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            myStyle: new TMap.MarkerStyle({
              width: 25, // 点标记样式宽度（像素）
              height: 35, // 点标记样式高度（像素）
              src: this.markerIcon, //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              anchor: { x: 16, y: 32 },
            }),
          },
          //点标记数据数组
          geometries: [
            {
              id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              styleId: "myStyle", //指定样式id
              position: new TMap.LatLng(point[0], point[1]), //点标记坐标位置
              properties: {
                //自定义属性
                title: this.label,
              },
            },
          ],
        });
      });
    },
    fnClose() {
      this.$emit("showMap", false);
    },
    fnNavigate(point, mode) {
      var url;
      if (mode == "gaode") {
        point = altCoords.BDtoGD(point[0], point[1]);
        url = `//uri.amap.com/navigation?from=,我的位置&to=${point[1]},${point[0]},${this.label}&mode=car&src=昆明市水利学会&coordinate=gaode&callnative=0`;
      } else if (mode == "baidu") {
        url = `http://api.map.baidu.com/direction?origin=我的位置&destination=name:${this.label}|latlng:${point[0]},${point[1]}&mode=driving&output=html&src=webapp.baidu.openAPIdemo`;
      } else {
        point = altCoords.BDtoGD(point[0], point[1]);
        url = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&to=${this.label}&tocoord=${point[0]},${point[1]}&policy=1&referer=${this.mapKey}`;
      }
      // console.log(url);
      location.href = url;
    },
  },
};
</script>
<style lang="scss">
$mapHeight: 360px;
html,
body {
  height: $mapHeight;
  margin: 0px;
  padding: 0px;
}
#mapArea {
  height: $mapHeight;
  width: 100%;
}
#navigate {
  .v-speed-dial {
    z-index: 1001;
    position: absolute;
  }
  .v-btn--floating {
    z-index: 1001;
    position: relative;
  }
}
</style>